import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import * as Icon from '@mui/icons-material';
import CustomTooltip from "../CustomTooltip";
import { extractDataFromArray, isValueEqual } from "../../utils/common";


const AvailableOptionsList = ({ header, tooltip, list }) => {
    return (
        <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                <Typography sx={{ fontWeight: 700 }}>{header}</Typography>
                {
                    tooltip &&
                    <CustomTooltip
                        content={
                            <Typography  >{tooltip}</Typography>
                        }
                    />
                }
            </Box>
            <Typography sx={{ alignItems: "center", display: 'flex' }}>
                Available : Yes&nbsp; <Icon.Verified color="primary" />
            </Typography>
            <Typography sx={{ color: 'var(--textGrey)', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                {tooltip}
            </Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                {
                    list.map((amenity, i) => {
                        return (
                            <Box sx={{ display: 'flex', gap: 1, flex: { xs: '100%', sm: '50%' }, width: '100%', mb: 1 }} key={"lodging_amenity_" + i}>
                                <Icon.Verified color="primary" />
                                <Typography color="grey">{amenity}</Typography>
                            </Box>
                        )
                    })
                }
            </Box>
        </Box>
    )
}

const CampingExperiencePreview = ({ campingData }) => {
    if (Object.keys(campingData).length === 0) return

    return (
        <>
            <Typography variant="h5" fontWeight={600}>
                Camping Experience
            </Typography>
            <Divider sx={{ mb: 3, mt: 2 }} />
            <Typography>
                <span style={{ fontWeight: 600 }}>Campsite name</span> : {campingData.name}
            </Typography>
            <Divider sx={{ mb: 3, mt: 2 }} />
            <Typography sx={{ color: 'var(--textGrey)', mb: 3 }}>
                {campingData.description}
            </Typography>
            {isValueEqual(extractDataFromArray(campingData, ['tent', 'available'], 'No'), 'Yes') && <AvailableOptionsList
                header={'Tents'}
                list={[]}
                tooltip={extractDataFromArray(campingData, ['tent', 'describe_tent_experience'], '')}
            />}
            {isValueEqual(extractDataFromArray(campingData, ['drinking_water', 'available'], 'No'), 'Yes') && <AvailableOptionsList
                header={'Drinking Water'}
                list={[]}
            />}
            {isValueEqual(extractDataFromArray(campingData, ['water_hookup', 'available'], 'No'), 'Yes') && <AvailableOptionsList
                header={'Water Hookup'}
                list={[]}
                tooltip={extractDataFromArray(campingData, ['water_hookup', 'additional_info'], '')}
            />}
            {isValueEqual(extractDataFromArray(campingData, ['electric_hookup_access', 'available'], 'No'), 'Yes') && <AvailableOptionsList
                header={'Electric Hookup'}
                list={extractDataFromArray(campingData, ['electric_hookup_access', 'list'], '')}
            />}
            {isValueEqual(extractDataFromArray(campingData, ['generator', 'available'], 'No'), 'Yes') && <AvailableOptionsList
                header={'Generator'}
                list={extractDataFromArray(campingData, ['generator', 'list'], [])}
                tooltip={extractDataFromArray(campingData, ['generator', 'additional_info'], '')}
            />}
            {isValueEqual(extractDataFromArray(campingData, ['cooking_area', 'available'], 'No'), 'Yes') && <AvailableOptionsList
                header={'Cooking Area'}
                list={extractDataFromArray(campingData, ['cooking_area', 'list'], [])}
                tooltip={extractDataFromArray(campingData, ['cooking_area', 'additional_info'], '')}
            />}
            {isValueEqual(extractDataFromArray(campingData, ['garbage_area', 'available'], 'No'), 'Yes') && <AvailableOptionsList
                header={'Garbage Area'}
                list={extractDataFromArray(campingData, ['garbage_area', 'list'], [])}
                tooltip={extractDataFromArray(campingData, ['garbage_area', 'additional_info'], '')}
            />}
            {isValueEqual(extractDataFromArray(campingData, ['campfire', 'available'], 'No'), 'Yes') && <AvailableOptionsList
                header={'Campfire'}
                list={extractDataFromArray(campingData, ['campfire', 'list'], [])}
                tooltip={extractDataFromArray(campingData, ['campfire', 'additional_info'], '')}
            />}
            {isValueEqual(extractDataFromArray(campingData, ['sewage_hookup', 'available'], 'No'), 'Yes') && <AvailableOptionsList
                header={'Sewage Hookup'}
                list={extractDataFromArray(campingData, ['sewage_hookup', 'list'], [])}
                tooltip={extractDataFromArray(campingData, ['sewage_hookup', 'additional_info'], '')}
            />}
            {extractDataFromArray(campingData, ['additional_amenities', 'list'], []).length > 0 && <AvailableOptionsList
                header={'Additional Amenities'}
                list={extractDataFromArray(campingData, ['additional_amenities', 'list'], [])}
                tooltip={extractDataFromArray(campingData, ['additional_amenities', 'additional_info'], '')}
            />}
        </>
    );
};

export default CampingExperiencePreview;
